export const RedForm = () => {
  return (
    <svg
      width="1380"
      height="1718"
      viewBox="0 0 1380 1718"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1171.74 1611.39C1426.37 1799.35 1550.88 21.966 914.188 0.582612C381.775 -17.2986 179.726 911.509 97.9158 1093.5C-130.953 1435.51 66.5184 1158.14 438.493 1569.71C795.751 1965 917.102 1423.43 1171.74 1611.39Z"
        fill="#CC9287"
      />
    </svg>
  );
};
